export default function isTableEmpty(editor, tableId) {
  return editor.isTableCellsEmpty(editor.getTableCells(tableId));
}